import config from "@/../config";

export default new (class ModesHelper {
  constructor() {
    this.deviceManagerApi = config.value("VUE_APP_WEBAPI");
  }

  // Sorry we have to do this because we are insisting on using device manager api and coupling it with AmrPortal ...
  async IsDeviceManagerMode() {
    // AmrPortal is not configured to use device manager
    if (this.deviceManagerApi.includes("VUE_APP_WEBAPI")) {
      return false;
    }

    const requestOptions = {
      method: "GET",
      headers: {
        Accept: "application/json",
        "content-type": "application/json",
      },
      cache: "default",
    };

    if (!this.deviceManagerApi.endsWith("/")) {
      this.deviceManagerApi = this.deviceManagerApi + "/";
    }
    try {
      let result = await fetch(
        `${this.deviceManagerApi}api/v1/status`,
        requestOptions
      );

      if ([404, 500].includes(result.status)) {
        // si on ne peux pas récupérer le status on suppose que ça ne va pas.
        return false;
      } else if (result.status == 200) {
        const responseData = JSON.parse(await result.json());
        if (responseData.Status.toUpperCase() == "OK") return true;
        return false;
      } else {
        // something wrong with the device API
        return false;
      }
    } catch (e) {
      // L'api du device n'est pas disponible
      return false;
    }
  }
})();
